/*
 * @Author: tangke
 * @Date: 2019-03-02 12:30:31
 * @Last Modified by: others
 * @Last Modified time: 2019-03-02 17:56:46
 * 课程详情页面的classRemark弹窗下的Skill Assessment 下的评价组件
 */
 <template>
  <v-card min-height="200"
          class="grey lighten-4">
    <v-card-actions class="white">
      <label class="subheading">{{title}}</label>
      <v-spacer></v-spacer>
      <v-rating-tweak v-model="model"
                :length="descriptions.lenght"
                hover
                :empty-icon="icon"
                :full-icon="icon"
                @hover="handleHover"
                color="yellow accent-4"
                background-color="grey lighten-1">
      </v-rating-tweak>
    </v-card-actions>
    <v-card-text>{{description}}</v-card-text>
  </v-card>
</template>
<script>
import VRatingTweak from '@/components/VRatingTweak.ts'
import vmodel from '@/mixins/v-model'

export default {
  name: 'skillScore',
  mixins: [vmodel],
  components: { VRatingTweak },
  props: {
    title: {
      type: String
    },
    descriptions: {
      type: Array,
      required: true
    },
    icon: {
      default: '$vuetify.icons.ratingFull'
    }
  },
  data: () => ({
    hoverIndex: 0
  }),
  computed: {
    description () {
      if (this.descriptions && this.hoverIndex > 0 && this.hoverIndex <= this.descriptions.length) {
        return this.descriptions[this.hoverIndex - 1]
      }
      return `* This is the level description of ${this.title}. Each level represents a different level and the escription is different.`
    }
  },
  methods: {
    handleHover (index) {
      this.hoverIndex = index
    }
  }
}
</script>
